import { useDispatch, useSelector } from 'react-redux'
import './PageTitle.scss'
import { useState } from 'react'
import { logout, selectUser } from '../../utils/redux/userSlice'
import DropdownMenu from '../DropdownMenuComponent/dropdownmenu.component'
import { useTranslation } from 'react-i18next'
import ModalAboutComponent from '../ModalAboutCompnent/modal.component'
import { UserLanguages } from '../../utils/const'
import ModalChangePasswordComponent from '../ModalChangePasswordComponent/ModalChangePassword.component'
import { useTheme } from '../../utils/contexts/ThemeContext'
import ModalCustomizeTheme from '../ModalCustomizeTheme/ModalCustomizeTheme.component'
import { ROLES } from 'aw-consts'
import Image from 'react-bootstrap/Image'
import AwayterConnectLight from '../../utils/resources/awayter_connect_light_cropped.png'
import AwayterConnectDark from '../../utils/resources/awayter_connect_dark.png'

const PageTitle = (props: { realTitle: string, setShowMenu: () => void, changeLang: (id: string) => void }) => {

    const { realTitle } = props

    const user = useSelector(selectUser)
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false)
    const [showModalChangePwd, setShowModalChangePwd] = useState(false)
    const [showModalTheme, setShowModalTheme] = useState(false)

    const { theme, toggleTheme, getCustomThemeImage } = useTheme();

    const logOut = (e: any) => {
        e.preventDefault();

        dispatch(
            logout()
        );
    }

    const onChangeLang = (e: any) => {
        const languageValue = e.currentTarget.id
        props.changeLang(languageValue)
    }

    return (
        <>
            <ModalAboutComponent showModal={showModal} onHide={() => setShowModal(false)} />
            <ModalChangePasswordComponent showModal={showModalChangePwd} onHide={() => setShowModalChangePwd(false)} />
            <ModalCustomizeTheme showModal={showModalTheme} onHide={() => setShowModalTheme(false)} />

            <div className="d-flex align-items-center p-1 barTitle header-text" style={{backgroundColor:"var(--background-secondary"}}>
                <div className="col d-flex align-items-center ms-2">
                    <div className="d-block d-lg-none"><DropdownMenu /></div>
                    <div className="d-none d-lg-flex align-items-center">
                        <button onClick={props.setShowMenu} className="btn-Simple">
                            <i className="bi bi-list fs-4"></i>
                        </button>
                        <h4 className="ms-3 m-0">{realTitle}</h4>
                    </div>
                </div>

                <div className="col text-center m-0">
                    <div className='d-lg-block d-none'>
                    <Image className="" src={theme === 'custom' && getCustomThemeImage("logo") ? getCustomThemeImage("logo") : (theme === 'dark' ? AwayterConnectDark : AwayterConnectLight)} width='170' />
                    </div>
                    <h3 className="d-block d-lg-none m-0">{realTitle}</h3>
                </div>

                <div className="col me-2 text-end">
                    <div className="dropdown userDropDown">
                        <div className="d-inline-flex align-items-center userMenu" data-bs-auto-close="outside" data-bs-toggle="dropdown" aria-expanded="false">
                            <div className="d-none d-lg-block">
                                <p className="m-0">{user.user}</p>
                            </div>
                            <i className="bi bi-person-circle fs-3 ms-2"></i>
                        </div>
                        <ul className="dropdown-menu">
                            <li className="d-block d-lg-none"><a href="#" className="dropdown-item">{user.user}</a></li>
                            <li className="d-block d-lg-none"><hr className="dropdown-divider" /></li>

                            <li className="dropstart userMenu">
                                <a className="dropdown-item dropdown-toggle userMenuList" data-bs-toggle="dropdown">
                                    <i className="bi bi-translate"></i>
                                    <span className="ms-2 d-md-inline">{t('Language')}</span>
                                </a>
                                <ul className="dropdown-menu">
                                    {
                                        UserLanguages().map((l, i) => (
                                            <li key={i}><a id={l.id} onClick={onChangeLang} className="dropdown-item userMenuList"><i className="bi bi-chevron-double-right"></i><span className="ms-2 d-md-inline">{l.label}</span></a></li>
                                        ))
                                    }
                                </ul>
                            </li>
                            <li className="dropstart userMenu">
                                <a className="dropdown-item dropdown-toggle userMenuList" data-bs-toggle="dropdown">
                                    <i className="bi bi-palette"></i>
                                    <span className="ms-2 d-md-inline">{t('Theme')}</span>
                                </a>
                                <ul className="dropdown-menu">
                                    <li><a onClick={() => toggleTheme('light')} className="dropdown-item userMenuList"><i className="bi bi-sun-fill"></i><span className="ms-2 d-md-inline">{t('Light')}</span></a></li>
                                    <li><a onClick={() => toggleTheme('dark')} className="dropdown-item userMenuList"><i className="bi bi-moon-fill"></i><span className="ms-2 d-md-inline">{t('Dark')}</span></a></li>
                                    {user.role === ROLES.Administrator && <li><a onClick={() => toggleTheme('custom')} className="dropdown-item userMenuList"><i className="bi bi-brush-fill"></i><span className="ms-2 d-md-inline">{t('Custom')}</span></a></li>}
                                </ul>
                            </li>
                            {user.role === ROLES.Administrator &&
                                <li className="userMenu"><span className="dropdown-item userMenuList" onClick={() => setShowModalTheme(true)}>
                                    <i className="bi bi-paint-bucket"></i><span className="ms-2 d-md-inline">{t('EditTheme')}</span>
                                    </span>
                                </li>
                            }
                            <li className="userMenu">
                                <span className="dropdown-item userMenuList" onClick={() => setShowModalChangePwd(true)}>
                                    <i className="bi bi-key"></i>
                                    <span className="ms-2 d-md-inline">{t('ChangePassword')}</span>
                                </span>
                            </li>
                            <li className="userMenu">
                                <a className="dropdown-item userMenuList" onClick={() => setShowModal(true)}>
                                    <i className="bi bi-question-circle"></i>
                                    <span className="ms-2 d-md-inline">{t('AboutApp')}</span>
                                </a>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li className="userMenu">
                                <a className="dropdown-item userMenuList" onClick={logOut}>
                                    <i className="bi bi-box-arrow-left"></i>
                                    <span className="ms-2 d-md-inline">{t('Logout')}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )

}
export default PageTitle